import { ChargeInterface } from "../Entity/Entities/Charge/ChargeInterface";

class Filterer {

  public filterCharges(charges: ChargeInterface[], text: string = ""): ChargeInterface[] {
    // If there is no search text, return all of the charges.
    if (text.length === 0) {
      return charges;
    }

    return charges
      .filter((charge: ChargeInterface) => !!charge)
      .filter((charge: ChargeInterface) => {
        // Search display name of the Charge.
        if (charge.displayName.toLowerCase().includes(text.toLowerCase()) === true) {
          return true;
        }

        return false;
      });
  }

}

export default new Filterer();
